import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '../../../atomic/Buttons/Button';
import GenericModal from '../GenericModal';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import { getExerciseAggregate } from '../../../../modules/Exercise';
import { getClassAggregate } from '../../../../modules/Class';
import { getProgramAggregate } from '../../../../modules/Program';

const ModalStyled = styled(GenericModal)`
  display: flex;
  min-width: 400px;
  min-height: 200px;
`

const Container = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
`

const TopBar = styled.div`
  border-bottom: 1px solid #ccc;
`

const Header = styled.div`
  font-weight: 600;
  font-size: 18px;
`
const Subheader = styled.span`
  font-size: 14px;
  padding-left: 8px;
`

const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
  min-height: auto;
  max-height: 400px;
  overflow-y: scroll;
`

const ButtonContainer = styled.div`
  display: flex;
  margin-top: auto;
  justify-content: flex-end;
`

const ChipStyled = styled(Chip)`
  margin: 4px;
`

const GroupHeading = styled.div`
  display: flex;
  font-weight: 600;
  margin-top: 8px;
`
const GroupContent = styled(Content)`
  margin-bottom: 8px;
`

class SelectModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: [],
    };
  }

  componentDidMount() {
    this.resetValue();
  }
  
  async componentDidUpdate(prevProps) {
    const {
      aggregate,
      endpoint,
      exerciseState,
      getExerciseAggregate,
      classState,
      getClassAggregate,
      programState,
      getProgramAggregate,
      type,
      params,
    } = this.props;

    if (!prevProps.open && this.props.open) {
      if (aggregate) {
        switch (endpoint) {
          case 'exercises':
            if (!Object.keys(exerciseState.filters).length || !exerciseState.filters[type] || !exerciseState.filters[type].length) {
              await getExerciseAggregate({ type: type });
            }
            break;
          case 'classes':
            // need to factor in filter?
            if (!Object.keys(classState.filters).length || !classState.filters[type] || !classState.filters[type].length) {
              await getClassAggregate({ filter: params.filter, type: type });
            }
            break;
          case 'programs':
            if (!Object.keys(programState.filters).length || !programState.filters[type] || !programState.filters[type].length) {
              await getProgramAggregate({ filter: params.filter, type: type });
            }
            break;
          default:
            break;
        }
      }

      this.resetValue();
    }
  }

  resetValue= () => {
    const { defaultValue } = this.props;
    this.setState({ value: defaultValue })
  }

  createOptions = (group) => {
    const {
      aggregate,
      classState,
      exerciseState,
      limit,
      endpoint,
      type,
      programState,
    } = this.props;
    const { options } = group ? group : this.props;
    const { value } = this.state;

    const components = options.map((item, optionIndex) => {
      let avatar = {};
      let clickable = true;
      let color = 'default';
      let variant = 'outlined';

      // a selected item
      if (value.filter(obj => obj.value === item.value).length > 0) {
        color = 'primary';
        variant = 'default';
      }
      else if (limit && limit <= value.length) {
        clickable = false;
      }

      if (aggregate) {
        switch (endpoint) {
          case 'exercises':
            if (exerciseState.filters[type]) {
              const i = exerciseState.filters[type].findIndex(filter => filter.name === item.label || filter.name === item.value);
              if (i > -1) {
                avatar.avatar = <Avatar>{exerciseState.filters[type][i].count}</Avatar>;
              }
            }
            break;
          case 'classes':
            if (classState.filters[type]) {
              const i = classState.filters[type].findIndex(filter => filter.name === item.label);
              if (i > -1) {
                avatar.avatar = <Avatar>{classState.filters[type][i].count}</Avatar>;
              }
            }
            break;
          case 'programs':
            if (programState.filters[type]) {
              const i = programState.filters[type].findIndex(filter => filter.name === item.label);
              if (i > -1) {
                avatar.avatar = <Avatar>{programState.filters[type][i].count}</Avatar>;
              }
            }
            break;
          default:
            break;
        }
      }

      return <ChipStyled
          key={`chip-option-${optionIndex}`}
          color={color}
          clickable={clickable}
          label={item.label}
          variant={variant}
          onClick={() => this.handleOptionClick(item)}
          {...avatar}
        />
    });

    return components;
  }

  createGroupings = () => {
    const { options } = this.props;

    const result = options.reduce((r, o) => {
      const grouping = o.grouping ? o.grouping : '';
      r[grouping] = (r[grouping] || []).concat(o);
      return r;
    }, Object.create(null));

    return Object.keys(result).map((group, index) => (
      <React.Fragment key={`group-${index}`}>
        <GroupHeading>{group}</GroupHeading>
        <GroupContent>
          {this.createOptions({options: result[group]})}
        </GroupContent>
      </React.Fragment>
    ));
  }

  handleOptionClick = item => {
    const { limit, multiple } = this.props;
    const { value } = this.state;
    let modValue = [...value];
    let indexedItem = -1;

    if (!multiple) {
      modValue = [item];
    } else if (modValue.filter((modItem,index) => {
      if(modItem.value === item.value) {
        indexedItem = index;
        return true;
      } else {
        return false;
      }
    }).length > 0) {
      modValue.splice(indexedItem,1);
    } else if (!limit || limit > value.length) {
      modValue.push(item);
    }

    this.setState({ value: modValue })
  }

  clearValue = () => {
    this.setState({ value: [] })
  }

  submitValue = () => {
    const { onClose, onSubmit } = this.props;
    const { value } = this.state;
    onSubmit(value);
    onClose();
  }

  render() {
    const {
      header,
      onClose,
      submitText,
      grouping,
      limit,
      ...other
    } = this.props;

    return (
      <ModalStyled {...other} onClose={onClose}>
        <Container>
          <TopBar>
            <Header>
              {header}
              {limit > 0 &&
                <Subheader>(Max {limit})</Subheader>
              }
            </Header>
          </TopBar>
          <Content>
            {grouping ? this.createGroupings() : this.createOptions()}
          </Content>
          <ButtonContainer>
            <Button color="secondary" onClick={this.clearValue}>Clear</Button>
            <Button onClick={this.submitValue}>{submitText}</Button>
          </ButtonContainer>
        </Container>
      </ModalStyled>
    )
  }
}

SelectModal.propTypes = {
  options: PropTypes.array.isRequired,
  multiple: PropTypes.bool,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  header: PropTypes.string,
  defaultValue: PropTypes.array,
  grouping: PropTypes.bool,
  aggregate: PropTypes.bool,
  endpoint: PropTypes.string,
  type: PropTypes.string,
  limit: PropTypes.number,
};

SelectModal.defaultProps = {
  multiple: false,
  header: 'Header',
  submitText: 'See Results',
  grouping: false,
  aggregate: false,
  limit: 0,
}

function mapStateToProps(state) {
  return {
    exerciseState: state.exerciseState,
    classState: state.classState,
    programState: state.programState,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getExerciseAggregate: getExerciseAggregate,
    getClassAggregate: getClassAggregate,
    getProgramAggregate: getProgramAggregate,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectModal);
